export const isSSN = validate => {
  return new RegExp(/^\d{12}$/).test(validate);
};
